import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { Store } from "../models/store";
import { OrdersWithPayment } from "../models/order";
import { OrderService } from "../order.service";
import { CountDownService } from "../_services/count-down.service";
import { Subscription } from "rxjs";
import { IMqttMessage, IPublishOptions, MqttService } from "ngx-mqtt";
import { IClientSubscribeOptions } from "mqtt/types/lib/client-options";
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DEVICE_TOKEN_KEY } from '../_helpers/auth.interceptor';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserLoginComponent } from '../order-summary/user-login/user-login.component';

@Component({
  selector: "app-store-header",
  templateUrl: "./store-header.component.html",
  styleUrls: ["./store-header.component.sass"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreHeaderComponent implements OnInit, OnDestroy {
  openStore;
  closeStore;
  isStoreOpen = false;
  idStore: any;
  convertCurrentDate: any;
  fromdateTime: any;
  todateTIme: any;
  status: any;
  showDiscliamer: boolean;
  toggle: boolean;
  interval;
  isSocketActive: boolean;
  header: boolean = false;
  dateObject: Date;

  @Input() store: Store;
  @Input() shareURL: string;
  @Input() title: string;
  @Input() orderHash: string;
  @Input() userHash: string;

  /**
   * ENG-5610/5611: the account section of this menu is everything that belongs to a phone number —
   * wallet, order history, loyalty, activity, rewards, gift cards. A user hash only says a number
   * was typed into this browser once, not that it belongs to whoever is holding the phone, and the
   * server now returns nothing for those pages without proof. Showing them unverified offers a
   * door that opens onto an empty room.
   *
   * The device token is that proof: the server issues it only after a code is verified.
   */
  get isVerifiedDevice(): boolean {
    try {
      return !!localStorage.getItem(DEVICE_TOKEN_KEY);
    } catch (e) {
      return false;   // private window or blocked storage
    }
  }

  /**
   * Loyalty is the one account page a guest goes looking for before they have ordered, so it
   * cannot hide behind isVerifiedDevice like the rest of My Account: a first-time or logged-out
   * guest had no way to reach it at all. Verified browsers go straight there; everyone else
   * proves their number in the login dialog first, which also saves a device token.
   */
  openLoyalty() {
    const slug = this.store?.url_slug;
    if (!slug) {
      return;
    }
    if (this.isVerifiedDevice && this.effectiveUserHash) {
      this.router.navigate(['store', slug, this.effectiveUserHash, 'loyalty']);
      return;
    }
    const dialogRef = this.dialog.open(UserLoginComponent, {
      disableClose: true,
      width: '400px',
      data: { store: slug, title: 'Log in to see your rewards' }
    });
    dialogRef.afterClosed().subscribe(phoneHash => {
      if (phoneHash) {
        this.userHash = phoneHash;
        localStorage.setItem('userHash', phoneHash);
        this.router.navigate(['store', slug, phoneHash, 'loyalty']);
      }
    });
  }

  get effectiveUserHash(): string {
    return this.userHash || localStorage.getItem('userHash') || '';
  }

  @Input() showShare: boolean = false;
  @Input() showMenu: boolean = false;
  @Input() showHours: boolean = false;
  @Input() showLogo: boolean = false;
  @Input() showBack: boolean = false;
  @Input() showStoreInfo: boolean = false;
  @Input() showTitle: boolean = false;
  @Input() orderWithPayment: OrdersWithPayment;
  @Output() back = new EventEmitter<boolean>();
  logo;
  private subscription: Subscription
  countdownFormatted: any;
  countdownValue: any;
  private countdownSubscription: Subscription;
  mqtSub;
  disclaimerMessage: string;

  constructor(
    private orderService: OrderService,
    private countdownService: CountDownService,
    private changeDetectorRef: ChangeDetectorRef,
    private mqttService: MqttService,
    private _snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.idStore = localStorage.getItem("currentStore");
    if (this.store?.id) {
      this.orderService.getStoreLogo(this.store.id).subscribe((data) => {
        this.logo = data;
        this.changeDetectorRef.markForCheck();
      });
    }

    if (!this.userHash) {
      this.userHash = localStorage.getItem('userHash');
    }
    if (this.userHash) {
      localStorage.setItem("userHash", this.userHash);
    }
    this.discliamerShownUpdate();

    // if (this.store.disclaimer_show == true) {
    //   if (!this.interval) {
    //     console.log(" after every 30 second");

    //     this.interval = setInterval(() => {
    //       this.discliamerShownUpdate();
    //     }, 30000);
    //   }
    // }

    this.mqttService.onConnect.subscribe(x => {
      this.isSocketActive = true;
      // this._snackBar.open('Connection MQTT established successfully.', 'OK', { duration: 2000 });
    });

    this.mqttService.onReconnect.subscribe(x => {
      // this._snackBar.open('Connection to the server is lost, retrying to establish a connection in 5 seconds.');
      // this.isListening = false;
    });

    this.mqttService.onClose.subscribe(x => {
      // this._snackBar.open('Connection to the server closed.');
      this.isSocketActive = false;
      // this.isListening = false;
    });

    setTimeout(() => {
      this.header == true;

      if (this.store?.id) {
        this.orderService.getStoreLogo(this.store.id).subscribe((data) => {
          this.logo = data;
        });
      }

      if (this.userHash) {
        localStorage.setItem("userHash", this.userHash);
      }
      this.discliamerShownUpdate();
    }, 1500)


    /* COUNT DOWN BEGINS */
    const aa = localStorage.getItem('dayPause');
    const countLocalValue = localStorage.getItem('countdownValue');
    if (countLocalValue) {
      if ((this.store.pause_store == false && this.store.pause_store_whole_day == true) || (this.store.pause_store == true && this.store.pause_store_whole_day == false)) {
        if (aa == 'day_pause' || aa == 'whole_day_pause') {
          this.stopCountdown();
          setTimeout(() => {
            this.countDownTimer();
          }, 1500);
        }
      } else {
        this.countDownTimer();
      }
    } else {
      this.countDownTimer();
    }
    /* COUNT DOWN STOP */
    this.initMqtt();

    if (this.store) {
      let htmlContent = this.store.disclaimer_message;
      if (htmlContent) {

        htmlContent = this.addCustomClass(htmlContent);
        this.disclaimerMessage = htmlContent;   // ENG-5906: Angular's sanitizer cleans it where it is bound with [innerHTML]
      }
    }

  }

  addCustomClass(htmlContent: string): string {
    const customClass = 'custom-font';
    const classAddedContent = htmlContent.replace('<font ', `<font class="${customClass}" `);
    return classAddedContent;
  }

  goBack() {
    this.back.emit(true);
  }

  copyMessage(val: string) {
    navigator.clipboard.writeText(val).then(() => {
      this._snackBar.open("Link copied to clipboard!", "OK", {
        duration: 1000,
        verticalPosition: "top",
      });
    });
  }

  discliamerShownUpdate() {
    if (this.store) {
      if (this.store.disclaimer_show != undefined || this.store.disclaimer_show != null) {
        this.toggle = this.store.disclaimer_show;
      }
      this.fromdateTime = this.store.disclaimer_from_time;
      this.todateTIme = this.store.disclaimer_to_time;
      var current = new Date();
      this.convertCurrentDate = new Date(current).toISOString();

      if (this.toggle == true) {
        if (this.convertCurrentDate >= this.fromdateTime) {
          this.showDiscliamer = true;
        } else {
          this.showDiscliamer = false;
        }
      }

        const keySend = {};
        this.orderService
          .updateDisclaimerShow(this.idStore, keySend)
          .subscribe((data: any) => {
            this.status = data.status;
          });

    }
  }

  /* COUNT DOWN BEGINS */
  countDownTimer() {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
      this.countdownSubscription = null;
    }
    if (this.store) {
      this.countdownValue = parseInt(localStorage.getItem('countdownValue') || '0', 10);
      if (this.store.pause_store) {
        if (this.countdownValue > 0) {
          const countDownValue = (this.countdownValue / 60);
          this.startCountdown(countDownValue);
          this.subscribeToCountdownChanges();
          this.updateCountdownFormatted();
        } else {
          localStorage.setItem('dayPause', 'day_pause')
          const targetDate = new Date(this.store.store_pause_date_time);
          const currentDate = new Date();
          if (currentDate < targetDate) {
            const timeDifference = Math.abs(currentDate.getTime() - targetDate.getTime());
            const minutesDifference = (timeDifference / (1000 * 60));
            this.countdownService.setInitialCountdownValue(minutesDifference);
            this.subscribeToCountdownChanges();
            this.updateCountdownFormatted();
          }
        }
      } else if (this.store.pause_store_whole_day) {
        if (this.countdownValue > 0) {
          const countDownValue = this.countdownValue / 60;
          this.startCountdown(countDownValue);
          this.subscribeToCountdownChanges();
          this.updateCountdownFormatted();
        } else {
          localStorage.setItem('dayPause', 'whole_day_pause');

          const targetUtc = this.store.store_whole_day_pause_date_time
            ? new Date(this.store.store_whole_day_pause_date_time)  // keep the Z, treat as UTC
            : null;
          const now = new Date();  // JS Date stores UTC internally

          if (targetUtc && now < targetUtc) {
            const diffMs = targetUtc.getTime() - now.getTime();
            const minutesDifference = diffMs / (1000 * 60);
            this.countdownService.setInitialCountdownValue(minutesDifference);
            this.subscribeToCountdownChanges();
            this.updateCountdownFormatted();
          }
        }
      } else {
        localStorage.removeItem('countdownValue');
      }
    }
  }
  startCountdown(minutes: number): void {
    this.countdownService.startCountdown(minutes);
    this.countdownValue = this.countdownService.getCountdownValue();
    localStorage.setItem('countdownValue', this.countdownValue.toString());
    this.updateCountdownFormatted();
    this.changeDetectorRef.detectChanges();
  }

  stopCountdown(): void {
    this.countdownService.stopCountdown();
    this.countdownValue = this.countdownService.getCountdownValue();
    localStorage.removeItem('countdownValue');
    this.updateCountdownFormatted();
    this.changeDetectorRef.detectChanges();
  }

  private subscribeToCountdownChanges(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
      this.countdownSubscription = null;
    }
    this.countdownSubscription = this.countdownService.subscribeToChanges().subscribe(() => {
      this.countdownValue = this.countdownService.getCountdownValue();
      this.updateCountdownFormatted();
      this.changeDetectorRef.detectChanges();
      if (this.countdownValue == 1) {
        localStorage.removeItem('countdownValue');
        const payload = {
          "pause_store": false,
          "pause_store_whole_day": false,
          "store_pause_time": null
        }
        this.orderService.pauseStoreService(this.store.id, payload).subscribe((data: any) => {
          location.reload();
        });
      }
    });
  }

  private updateCountdownFormatted(): void {
    this.countdownFormatted = this.countdownService.convertToHHMMSS(this.countdownValue);
  }
  /* COUNT DOWN STOP */

  /* MQTT IMPLEMENTATION */
  initMqtt() {
    let currentStoreId = localStorage.getItem("currentStore")
    this.mqtSub = this.mqttService.observe(`/order_app/${currentStoreId}/sub`,
      { qos: 1 } as IClientSubscribeOptions).subscribe((message: IMqttMessage) => {
        const response = JSON.parse(message.payload.toString());
        if (response) {
          location.reload();
        }
      });
  }

  publish(payload: string) {
    const qos = 2;
    if (this.store) {
      this.mqttService.unsafePublish(`/order_app/${this.store.id}/sub`, payload, { qos } as IPublishOptions);
    }
  }

  reconnectMqttServer() {
    this.mqttService.connect();
    const payload = {
      command: 'RECONNECT'
    };
    this.publish(JSON.stringify(payload));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
  removeLocal() {
    localStorage.removeItem('menu_group_name');
  }
}
